module.exports = __webpack_public_path__ + "img/transactions.f422eb9c.svg";